/* LH | Size chart next to TeeInBlue's size label (Leon 29.10.2026). Markup, styles and texts: snippets/lh-size-chart.liquid.
   TeeInBlue draws its form late and redraws it, so a MutationObserver puts the button back whenever the size option
   is (re)drawn. The button is added inside .tee-option--size and placed on the label row by CSS; TeeInBlue's own
   nodes are not moved.
   The dialog shows every fit at once in one table, sizes as rows, unisex and women as two tinted column blocks
   (Leon 29.10.2026, layout 2 of the preview round), read from the description tables in #lh-sc-tpl. A product with
   one table only (older ES T-shirt) gets the same table without blocks. */
(function () {
  'use strict';
  var tpl = document.getElementById('lh-sc-tpl');
  var cfgEl = document.getElementById('lh-sc-cfg');
  if (!tpl || !cfgEl) return;
  var T = {};
  try { T = JSON.parse(cfgEl.textContent).t || {}; } catch (e) { return; }

  var TAPE = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="12" r="6.5"/><circle cx="9" cy="12" r="1.8"/><path d="M9 18.5h13v-4h-6.5"/><path d="M13 18.5v-2M16.5 18.5v-2M20 18.5v-2"/></svg>';
  var CLOSE = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  /* T-shirt outline, A across the chest, B from the shoulder down to the hem */
  function shirt(w) {
    return '<svg width="' + w + '" height="' + Math.round(w * 0.93) + '" viewBox="0 0 112 104" aria-hidden="true"><path d="M38 6 L22 12 L4 30 L18 44 L28 36 L28 98 L84 98 L84 36 L94 44 L108 30 L90 12 L74 6 C70 14 62 18 56 18 C50 18 42 14 38 6 Z" fill="#f7eef8" stroke="#8a8a8a" stroke-width="1.5" stroke-linejoin="round"/><path d="M31 44 H81 M31 40 V48 M81 40 V48" stroke="#b0479f" stroke-width="2"/><text x="56" y="39" text-anchor="middle" font-size="12" font-weight="700" fill="#b0479f">A</text><path d="M66 10 V96" stroke="#b0479f" stroke-width="1.6" stroke-dasharray="3 3"/><text x="73" y="70" font-size="12" font-weight="700" fill="#b0479f">B</text></svg>';
  }

  var sheet = null;
  var fits = [];
  var lastFocus = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function text(el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  /* "T-Shirt (Passform für Frauen)" -> "Passform für Frauen", a title without brackets stays as it is */
  function fitOf(title) {
    var m = /\(([^)]+)\)/.exec(title || '');
    return (m ? m[1] : title || '').trim();
  }

  function sizeSelect() { return document.querySelector('.tee-option--size select'); }
  /* "M (unisex)" -> { label, size: "m", fit: "unisex" }; nothing while the placeholder is selected */
  function picked() {
    var s = sizeSelect();
    if (!s || !s.value || s.selectedIndex < 0) return null;
    var label = text(s.options[s.selectedIndex]);
    var m = /^(\S+)\s*(?:\(([^)]+)\))?/.exec(label);
    if (!m) return null;
    return { label: label, size: m[1].toLowerCase(), fit: (m[2] || '').toLowerCase() };
  }
  /* The dropdown says "femmes", the table "Femme": either one may contain the other */
  function fitFor(fit) {
    if (fits.length === 1) return 0;
    if (!fit) return -1;
    for (var i = 0; i < fits.length; i++) {
      var f = fits[i].fit.toLowerCase();
      if (f && (f.indexOf(fit) >= 0 || fit.indexOf(f) >= 0)) return i;
    }
    return -1;
  }

  /* Description table -> { fit, sizeHead, sizes: [S, M, ...], rows: [{ name: "A", vals: ["46", ...] }], cm } */
  function readTable(panel) {
    var table = panel.querySelector('table');
    if (!table) return null;
    var head = Array.prototype.map.call(table.querySelectorAll('thead th'), text);
    var rows = Array.prototype.map.call(table.querySelectorAll('tbody tr'), function (r) {
      var c = Array.prototype.map.call(r.children, text);
      return { name: c[0], vals: c.slice(1) };
    });
    /* "71 cm" in every cell does not fit 8 sizes on a 375 px phone: numbers only, "(cm)" once in the head */
    var cm = rows.length > 0 && rows.every(function (r) { return r.vals.every(function (v) { return /^[\d.,]+\s*cm$/i.test(v); }); });
    if (cm) rows.forEach(function (r) { r.vals = r.vals.map(function (v) { return v.replace(/\s*cm$/i, ''); }); });
    var fit = fitOf(panel.getAttribute('data-title'));
    return { fit: fit, women: !/unisex/i.test(fit), sizeHead: head[0] || '', sizes: head.slice(1), rows: rows, cm: cm };
  }

  /* "Unisex" or "Frauen · tailliert" (theme texts, the description words differ per language) */
  function fitTitle(f) {
    if (fits.length < 2) return '';
    if (!f.women) return '<span class="lh-sc__fit-name">' + esc(cap(f.fit)) + '</span>';
    return '<span class="lh-sc__fit-name">' + esc(T.women) + '</span> <span class="lh-sc__chip">' + esc(T.tailored) + '</span>';
  }
  function sizeHead(f) { return esc(f.sizeHead) + (f.cm ? ' (cm)' : ''); }

  /* One table, sizes as rows, each fit gets its own column group. The groups are two tinted blocks with a gap
     between them (Leon 29.10.2026: unisex and women clearly apart): grey for unisex, mauve for women. */
  function layoutCombined(pk) {
    if (fits.length < 2) return layoutSingle(pk);
    var sizes = [];
    fits.forEach(function (f) { f.sizes.forEach(function (s) { if (sizes.indexOf(s) < 0) sizes.push(s); }); });
    var gap = '<td class="lh-sc__gap" aria-hidden="true"></td>';
    var grp = function (f) { return f.women ? ' lh-sc__w' : ' lh-sc__u'; };
    /* cls: corner classes so each block gets rounded corners */
    var corner = function (f, k, row) {
      var c = '';
      if (row === 'last' && k === 0) c += ' lh-sc__bl';
      if (row === 'last' && k === f.rows.length - 1) c += ' lh-sc__br';
      return c;
    };
    var h1 = '<tr><th></th>' + fits.map(function (f, i) { return (i ? gap : '') + '<th colspan="' + f.rows.length + '" class="lh-sc__grp' + grp(f) + '">' + fitTitle(f) + '</th>'; }).join('') + '</tr>';
    var h2 = '<tr><th>' + sizeHead(fits[0]) + '</th>' + fits.map(function (f, i) { return (i ? gap : '') + f.rows.map(function (r) { return '<th class="lh-sc__ab' + grp(f) + '">' + esc(r.name) + '</th>'; }).join(''); }).join('') + '</tr>';
    var body = sizes.map(function (s, n) {
      var row = n === sizes.length - 1 ? 'last' : '';
      return '<tr><th>' + esc(s) + '</th>' + fits.map(function (f, i) {
        var j = f.sizes.indexOf(s);
        var on = pk && pk.fi === i && s.toLowerCase() === pk.size;
        return (i ? gap : '') + f.rows.map(function (r, k) {
          var c = grp(f) + corner(f, k, row);
          return j < 0 ? '<td class="lh-sc__none' + c + '">·</td>' : '<td class="' + c.trim() + (on ? ' is-hl' : '') + '">' + esc(r.vals[j]) + '</td>';
        }).join('');
      }).join('') + '</tr>';
    }).join('');
    return '<table class="lh-sc__t lh-sc__t--rows lh-sc__t--grp"><thead>' + h1 + h2 + '</thead><tbody>' + body + '</tbody></table>';
  }

  /* A single fit (older ES T-shirt, one table): sizes as rows in one card */
  function layoutSingle(pk) {
    return '<div class="lh-sc__cards' + (fits.length < 2 ? ' lh-sc__cards--one' : '') + '">' + fits.map(function (f, i) {
      return '<section class="lh-sc__card">' + (fitTitle(f) ? '<h3 class="lh-sc__fit-h">' + fitTitle(f) + '</h3>' : '') +
        '<table class="lh-sc__t lh-sc__t--rows"><thead><tr><th>' + sizeHead(f) + '</th>' + f.rows.map(function (r) { return '<th class="lh-sc__ab">' + esc(r.name) + '</th>'; }).join('') + '</tr></thead><tbody>' +
        f.sizes.map(function (s, j) {
          var on = pk && pk.fi === i && s.toLowerCase() === pk.size;
          return '<tr' + (on ? ' class="is-hl"' : '') + '><th>' + esc(s) + '</th>' + f.rows.map(function (r) { return '<td>' + esc(r.vals[j]) + '</td>'; }).join('') + '</tr>';
        }).join('') + '</tbody></table></section>';
    }).join('') + '</div>';
  }

  function build() {
    Array.prototype.forEach.call(tpl.content.querySelectorAll('.lh-sc__panel'), function (p) {
      var f = readTable(p);
      if (f) fits.push(f);
    });
    var ab = fits.some(function (f) {
      var n = f.rows.map(function (r) { return r.name.toUpperCase(); });
      return n.indexOf('A') >= 0 && n.indexOf('B') >= 0;
    });
    sheet = document.createElement('div');
    sheet.className = 'lh-sc';
    sheet.innerHTML =
      '<button type="button" class="lh-sc__bg" tabindex="-1" aria-label="' + esc(T.close) + '"></button>' +
      '<div class="lh-sc__sheet" role="dialog" aria-modal="true" aria-labelledby="lh-sc-h">' +
      '<div class="lh-sc__head"><h2 id="lh-sc-h">' + esc(T.open) + '</h2><button type="button" class="lh-sc__x" aria-label="' + esc(T.close) + '">' + CLOSE + '</button></div>' +
      (ab ? '<div class="lh-sc__legend">' + shirt(78) + '<ul><li><b>A</b> ' + esc(T.a) + '</li><li><b>B</b> ' + esc(T.b) + '</li><li>' + esc(T.unit) + '</li></ul></div>' : '') +
      '<div class="lh-sc__body"></div>' +
      '<p class="lh-sc__pick" hidden></p>' +
      '<button type="button" class="lh-sc__ok">' + esc(T.ok) + '</button>' +
      '</div>';
    sheet.querySelector('.lh-sc__bg').addEventListener('click', close);
    sheet.querySelector('.lh-sc__x').addEventListener('click', close);
    sheet.querySelector('.lh-sc__ok').addEventListener('click', close);
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
    });
    document.body.appendChild(sheet);
  }

  /* Draws the tables with the picked size highlighted and repeats its measures below them */
  function render() {
    var pk = picked();
    if (pk) {
      pk.fi = fitFor(pk.fit);
      if (pk.fi < 0 || fits[pk.fi].sizes.map(function (s) { return s.toLowerCase(); }).indexOf(pk.size) < 0) pk = null;
    }
    var body = sheet.querySelector('.lh-sc__body');
    body.innerHTML = layoutCombined(pk);
    var note = sheet.querySelector('.lh-sc__pick');
    note.hidden = !pk;
    if (!pk) return;
    var f = fits[pk.fi];
    var j = f.sizes.map(function (s) { return s.toLowerCase(); }).indexOf(pk.size);
    note.innerHTML = esc(T.pick) + ' <b>' + esc(pk.label) + '</b>: ' + esc(f.rows.map(function (r) { return r.name + ' ' + r.vals[j] + (f.cm ? ' cm' : ''); }).join(', '));
  }

  function open(btn) {
    if (!sheet) build();
    render();
    lastFocus = btn;
    sheet.classList.add('is-open');
    document.documentElement.classList.add('lh-sc-lock');
    sheet.querySelector('.lh-sc__x').focus();
  }

  function close() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('lh-sc-lock');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }

  function mount() {
    Array.prototype.forEach.call(document.querySelectorAll('.tee-option--size'), function (opt) {
      var label = opt.querySelector('.tee-option__title');
      if (!label) return;
      var btn = opt.querySelector(':scope > .lh-sc-btn');
      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lh-sc-btn';
        btn.setAttribute('aria-haspopup', 'dialog');
        btn.innerHTML = TAPE + '<span>' + esc(T.open) + '</span>';
        btn.addEventListener('click', function () { open(btn); });
        opt.classList.add('lh-sc-host');
        opt.appendChild(btn);
      }
      /* centred on the label line, wherever TeeInBlue puts the label */
      var top = Math.round(label.offsetTop + label.offsetHeight / 2 - 22) + 'px';
      if (btn.style.top !== top) btn.style.top = top;
    });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    /* setTimeout, not requestAnimationFrame: rAF stops in a background tab, the button must still be there */
    setTimeout(function () { queued = false; mount(); }, 60);
  }
  mount();
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', queue);
})();
